export default __webpack_public_path__ + "static/media/filesIcon.c442ae92.svg";